import { render } from "./AppToDoItems.vue?vue&type=template&id=1f567214&ts=true"
import script from "./AppToDoItems.vue?vue&type=script&lang=ts"
export * from "./AppToDoItems.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__